// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AtcControllerGetManyData,
  AtcControllerGetManyResponses,
  AuditControllerGetManyData,
  AuditControllerGetManyResponses,
  BankControllerGetManyData,
  BankControllerGetManyResponses,
  BillControllerCreateData,
  BillControllerCreateResponses,
  BillControllerDeleteData,
  BillControllerDeleteResponses,
  BillControllerGetData,
  BillControllerGetPageData,
  BillControllerGetPageResponses,
  BillControllerGetResponses,
  BillControllerUpdateData,
  BillControllerUpdateResponses,
  BrandControllerGetManyData,
  BrandControllerGetManyResponses,
  CashRegisterControllerCreateData,
  CashRegisterControllerCreateResponses,
  CashRegisterControllerGetCurrentByUserIdData,
  CashRegisterControllerGetCurrentByUserIdResponses,
  CashRegisterControllerGetData,
  CashRegisterControllerGetManyByDateData,
  CashRegisterControllerGetManyByDateResponses,
  CashRegisterControllerGetManyData,
  CashRegisterControllerGetManyResponses,
  CashRegisterControllerGetReportData,
  CashRegisterControllerGetReportResponses,
  CashRegisterControllerGetResponses,
  CashRegisterControllerUpdateData,
  CashRegisterControllerUpdateResponses,
  CashReplenishmentControllerCreateData,
  CashReplenishmentControllerCreateResponses,
  CashReplenishmentControllerDeleteData,
  CashReplenishmentControllerDeleteResponses,
  CashReplenishmentControllerGetData,
  CashReplenishmentControllerGetResponses,
  CashReplenishmentReasonControllerCreateData,
  CashReplenishmentReasonControllerCreateResponses,
  CashReplenishmentReasonControllerGetAllData,
  CashReplenishmentReasonControllerGetAllResponses,
  ClientControllerGetPageData,
  ClientControllerGetPageResponses,
  CompanyControllerGetAllData,
  CompanyControllerGetAllResponses,
  CompanyControllerGetManyData,
  CompanyControllerGetManyResponses,
  ContractControllerCreateData,
  ContractControllerCreateResponses,
  ContractControllerDeleteData,
  ContractControllerDeleteFromPolicyData,
  ContractControllerDeleteFromPolicyResponses,
  ContractControllerDeleteResponses,
  ContractControllerGetAffiliatedData,
  ContractControllerGetAffiliatedResponses,
  ContractControllerGetByCompanyIdData,
  ContractControllerGetByCompanyIdResponses,
  ContractControllerGetByIdData,
  ContractControllerGetByIdResponses,
  ContractControllerUpdateData,
  ContractControllerUpdateResponses,
  ContractPolicyControllerCreateData,
  ContractPolicyControllerCreateFromCompanyContractData,
  ContractPolicyControllerCreateFromCompanyContractResponses,
  ContractPolicyControllerCreateResponses,
  ContractPolicyControllerGetData,
  ContractPolicyControllerGetResponses,
  ContractPolicyControllerUpdateData,
  ContractPolicyControllerUpdateResponses,
  CountryControllerGetManyData,
  CountryControllerGetManyResponses,
  CountryControllerGetManySectionsData,
  CountryControllerGetManySectionsResponses,
  CountryControllerGetManySuppliersData,
  CountryControllerGetManySuppliersResponses,
  CurrencyControllerGetManyData,
  CurrencyControllerGetManyResponses,
  DeliveryControllerCreateData,
  DeliveryControllerCreateResponses,
  DeliveryControllerGetData,
  DeliveryControllerGetManyData,
  DeliveryControllerGetManyResponses,
  DeliveryControllerGetReportCsvData,
  DeliveryControllerGetReportCsvResponses,
  DeliveryControllerGetResponses,
  DeliveryControllerUpdateData,
  DeliveryControllerUpdateResponses,
  DisbursementControllerCreateData,
  DisbursementControllerCreateResponses,
  DisbursementControllerDeleteData,
  DisbursementControllerDeleteResponses,
  DisbursementControllerGetData,
  DisbursementControllerGetResponses,
  DisbursementReasonControllerCreateData,
  DisbursementReasonControllerCreateResponses,
  DisbursementReasonControllerGetAllData,
  DisbursementReasonControllerGetAllResponses,
  ExpenseControllerCreateData,
  ExpenseControllerCreateResponses,
  ExpenseControllerGetPageData,
  ExpenseControllerGetPageResponses,
  ExpenseControllerGetSummaryData,
  ExpenseControllerGetSummaryResponses,
  ExpenseControllerRemoveData,
  ExpenseControllerRemoveErrors,
  ExpenseControllerRemoveResponses,
  ExpenseControllerUpdateData,
  ExpenseControllerUpdateErrors,
  ExpenseControllerUpdateResponses,
  FormControllerGetManyData,
  FormControllerGetManyResponses,
  HealthControllerCheckData,
  HealthControllerCheckResponses,
  HealthControllerLivenessData,
  HealthControllerLivenessErrors,
  HealthControllerLivenessResponses,
  ImportDeliveryControllerImportBlData,
  ImportDeliveryControllerImportBlResponses,
  InnControllerCreateData,
  InnControllerCreateResponses,
  InnControllerGetManyData,
  InnControllerGetManyResponses,
  InventoryControllerCloseData,
  InventoryControllerCloseResponses,
  InventoryControllerCreateData,
  InventoryControllerCreateResponses,
  InventoryControllerDeleteData,
  InventoryControllerDeleteResponses,
  InventoryControllerGetData,
  InventoryControllerGetInventoryValuationReportDataData,
  InventoryControllerGetInventoryValuationReportDataResponses,
  InventoryControllerGetManyData,
  InventoryControllerGetManyResponses,
  InventoryControllerGetResponses,
  JwtControllerCreateTokenData,
  JwtControllerCreateTokenResponses,
  MeCeFControllerStatusData,
  MeCeFControllerStatusResponses,
  MeCeFControllerTestTokenData,
  MeCeFControllerTestTokenResponses,
  MovementControllerGetMovementsPageData,
  MovementControllerGetMovementsPageResponses,
  MovementControllerGetReportCsvData,
  MovementControllerGetReportCsvResponses,
  MovementControllerGetReportData,
  MovementControllerGetReportDataData,
  MovementControllerGetReportDataResponses,
  MovementControllerGetReportResponses,
  OrderControllerGetCsvData,
  OrderControllerGetCsvResponses,
  OrderControllerGetData,
  OrderControllerGetExportDataData,
  OrderControllerGetExportDataResponses,
  OrderControllerGetManyData,
  OrderControllerGetManyResponses,
  OrderControllerGetMeditectCsvData,
  OrderControllerGetMeditectCsvResponses,
  OrderControllerGetResponses,
  OrderControllerUpdateData,
  OrderControllerUpdateResponses,
  OrderPreparationControllerCloseData,
  OrderPreparationControllerCloseResponses,
  OrderPreparationControllerFindRecordsData,
  OrderPreparationControllerFindRecordsResponses,
  OrderPreparationControllerGetRecordStatByProductIdsData,
  OrderPreparationControllerGetRecordStatByProductIdsResponses,
  OrderRecordControllerDeleteData,
  OrderRecordControllerDeleteResponses,
  OrganizationContractPolicyControllerGetManyByAffiliatedData,
  OrganizationContractPolicyControllerGetManyByAffiliatedResponses,
  OrganizationContractPolicyControllerGetManyData,
  OrganizationContractPolicyControllerGetManyResponses,
  OrganizationControllerCreateData,
  OrganizationControllerCreateResponses,
  OrganizationControllerGetAllData,
  OrganizationControllerGetAllResponses,
  OrganizationControllerGetBillsData,
  OrganizationControllerGetBillsResponses,
  OrganizationControllerGetData,
  OrganizationControllerGetManyData,
  OrganizationControllerGetManyResponses,
  OrganizationControllerGetOutgoingData,
  OrganizationControllerGetOutgoingResponses,
  OrganizationControllerGetResponses,
  OrganizationControllerUpdateData,
  OrganizationControllerUpdateResponses,
  PackagingControllerGetManyData,
  PackagingControllerGetManyResponses,
  PaymentControllerUpdateDeferredMedataData,
  PaymentControllerUpdateDeferredMedataResponses,
  PaymentControllerUpdateInsuranceMedataData,
  PaymentControllerUpdateInsuranceMedataResponses,
  PersonContractPolicyControllerGetManyData,
  PersonContractPolicyControllerGetManyResponses,
  PersonControllerCreateData,
  PersonControllerCreatePatientByQuickWayData,
  PersonControllerCreatePatientByQuickWayResponses,
  PersonControllerCreateResponses,
  PersonControllerGetAllData,
  PersonControllerGetAllResponses,
  PersonControllerGetBillsData,
  PersonControllerGetBillsResponses,
  PersonControllerGetData,
  PersonControllerGetManyData,
  PersonControllerGetManyResponses,
  PersonControllerGetOutgoingData,
  PersonControllerGetOutgoingResponses,
  PersonControllerGetResponses,
  PersonControllerUpdateData,
  PersonControllerUpdatePatientByQuickWayData,
  PersonControllerUpdatePatientByQuickWayResponses,
  PersonControllerUpdateResponses,
  PersonRelationshipsControllerCreateData,
  PersonRelationshipsControllerCreateResponses,
  PersonRelationshipsControllerDeleteData,
  PersonRelationshipsControllerDeleteResponses,
  PersonRelationshipsControllerGetAllData,
  PersonRelationshipsControllerGetAllResponses,
  PharmacyControllerCreateData,
  PharmacyControllerCreateResponses,
  PharmacyControllerGetData,
  PharmacyControllerGetManyData,
  PharmacyControllerGetManyResponses,
  PharmacyControllerGetPageData,
  PharmacyControllerGetPageResponses,
  PharmacyControllerGetResponses,
  PharmacyControllerGetSubscriptionData,
  PharmacyControllerGetSubscriptionResponses,
  PharmacyControllerGetUsersData,
  PharmacyControllerGetUsersResponses,
  PharmacyControllerSoftDeleteData,
  PharmacyControllerSoftDeleteResponses,
  PharmacyControllerUndoSoftDeleteData,
  PharmacyControllerUndoSoftDeleteResponses,
  PharmacyControllerUpdateData,
  PharmacyControllerUpdatePrinterSettingsData,
  PharmacyControllerUpdatePrinterSettingsResponses,
  PharmacyControllerUpdateResponses,
  PharmacyProductControllerAssociateProductData,
  PharmacyProductControllerAssociateProductResponses,
  PharmacyProductControllerBatchUpdateData,
  PharmacyProductControllerBatchUpdateResponses,
  PharmacyProductControllerCreateData,
  PharmacyProductControllerCreateResponses,
  PharmacyProductControllerDeleteData,
  PharmacyProductControllerDeleteDepackagingSettingsData,
  PharmacyProductControllerDeleteDepackagingSettingsResponses,
  PharmacyProductControllerDeleteResponses,
  PharmacyProductControllerGetAllData,
  PharmacyProductControllerGetAllResponses,
  PharmacyProductControllerGetArchivedProductsData,
  PharmacyProductControllerGetArchivedProductsResponses,
  PharmacyProductControllerGetByDeliveryRecordIdData,
  PharmacyProductControllerGetByDeliveryRecordIdResponses,
  PharmacyProductControllerGetByIdsData,
  PharmacyProductControllerGetByIdsResponses,
  PharmacyProductControllerGetByStockItemIdData,
  PharmacyProductControllerGetByStockItemIdResponses,
  PharmacyProductControllerGetCountByStockQuantityData,
  PharmacyProductControllerGetCountByStockQuantityResponses,
  PharmacyProductControllerGetData,
  PharmacyProductControllerGetManyData,
  PharmacyProductControllerGetManyResponses,
  PharmacyProductControllerGetProductStatsData,
  PharmacyProductControllerGetProductStatsResponses,
  PharmacyProductControllerGetResponses,
  PharmacyProductControllerGetStatsData,
  PharmacyProductControllerGetStatsResponses,
  PharmacyProductControllerGetSubstituteProductsData,
  PharmacyProductControllerGetSubstituteProductsResponses,
  PharmacyProductControllerTaxRateUpdateData,
  PharmacyProductControllerTaxRateUpdateResponses,
  PharmacyProductControllerUnpackData,
  PharmacyProductControllerUnpackResponses,
  PharmacyProductControllerUpdateData,
  PharmacyProductControllerUpdateResponses,
  PharmacyProductControllerUpsertDepackagingSettingsData,
  PharmacyProductControllerUpsertDepackagingSettingsResponses,
  PharmacyProductStorageControllerCreateData,
  PharmacyProductStorageControllerCreateResponses,
  PharmacyProductStorageControllerDeleteData,
  PharmacyProductStorageControllerDeleteErrors,
  PharmacyProductStorageControllerDeleteResponses,
  PharmacyProductStorageControllerGetAllData,
  PharmacyProductStorageControllerGetAllResponses,
  PharmacyProductStorageControllerUpdateData,
  PharmacyProductStorageControllerUpdateResponses,
  PharmacySchedulerControllerHardDeleteData,
  PharmacySchedulerControllerHardDeleteResponses,
  PrintAgentControllerDownloadData,
  PrintAgentControllerDownloadResponses,
  ProductAdviceControllerPopulateAdvicesByIdsData,
  ProductAdviceControllerPopulateAdvicesByIdsResponses,
  ProductAdviceControllerPopulateAdvicesData,
  ProductAdviceControllerPopulateAdvicesResponses,
  ProductAdviceControllerSubmitFeedbackData,
  ProductAdviceControllerSubmitFeedbackErrors,
  ProductAdviceControllerSubmitFeedbackResponses,
  ProductCategoryControllerGetAllData,
  ProductCategoryControllerGetAllResponses,
  ProductControllerArchiveData,
  ProductControllerArchiveResponses,
  ProductControllerCreateBatchData,
  ProductControllerCreateBatchResponses,
  ProductControllerCreateData,
  ProductControllerCreateResponses,
  ProductControllerDeleteData,
  ProductControllerDeleteResponses,
  ProductControllerGetAllByProductIdData,
  ProductControllerGetAllByProductIdResponses,
  ProductControllerGetArchivedProductsData,
  ProductControllerGetArchivedProductsResponses,
  ProductControllerGetByLabelWithHealthInsuranceData,
  ProductControllerGetByLabelWithHealthInsuranceResponses,
  ProductControllerGetByWholesalerProductLabelData,
  ProductControllerGetByWholesalerProductLabelResponses,
  ProductControllerGetData,
  ProductControllerGetFullData,
  ProductControllerGetFullResponses,
  ProductControllerGetManyData,
  ProductControllerGetManyResponses,
  ProductControllerGetNoticeData,
  ProductControllerGetNoticeResponses,
  ProductControllerGetResponses,
  ProductControllerGetSpcData,
  ProductControllerGetSpcResponses,
  ProductControllerUpdateData,
  ProductControllerUpdateReferentialData,
  ProductControllerUpdateReferentialResponses,
  ProductControllerUpdateResponses,
  ProductHealthInsuranceControllerAddProductsFromJsonData,
  ProductHealthInsuranceControllerAddProductsFromJsonResponses,
  ProductHealthInsuranceControllerAddProductsFromPharmaPlusData,
  ProductHealthInsuranceControllerAddProductsFromPharmaPlusResponses,
  ProductHealthInsuranceControllerAssociateProductData,
  ProductHealthInsuranceControllerAssociateProductResponses,
  ProductHealthInsuranceControllerCreateData,
  ProductHealthInsuranceControllerCreateResponses,
  ProductHealthInsuranceControllerDeleteData,
  ProductHealthInsuranceControllerDeleteResponses,
  ProductHealthInsuranceControllerFindAllData,
  ProductHealthInsuranceControllerFindAllResponses,
  ProductHealthInsuranceControllerFindAllWithAssociatedProductData,
  ProductHealthInsuranceControllerFindAllWithAssociatedProductResponses,
  ProductHealthInsuranceControllerUpdateData,
  ProductHealthInsuranceControllerUpdateResponses,
  ProductViewControllerCreateData,
  ProductViewControllerCreateResponses,
  ProductViewControllerGetPageData,
  ProductViewControllerGetPageResponses,
  ReportsControllerCreateData,
  ReportsControllerCreateResponses,
  RoleControllerCreateData,
  RoleControllerCreateResponses,
  RoleControllerDeleteData,
  RoleControllerDeleteResponses,
  RoleControllerGetData,
  RoleControllerGetManyData,
  RoleControllerGetManyResponses,
  RoleControllerGetResponses,
  RoleControllerUpdateData,
  RoleControllerUpdateResponses,
  SaleControllerCreateData,
  SaleControllerCreateProformaData,
  SaleControllerCreateProformaResponses,
  SaleControllerCreateResponses,
  SaleControllerDeleteData,
  SaleControllerDeleteResponses,
  SaleControllerGetData,
  SaleControllerGetHistoryData,
  SaleControllerGetHistoryResponses,
  SaleControllerGetManyData,
  SaleControllerGetManyResponses,
  SaleControllerGetManyWithVouchersData,
  SaleControllerGetManyWithVouchersResponses,
  SaleControllerGetResponses,
  SaleControllerNormalizeData,
  SaleControllerNormalizeResponses,
  SaleControllerRedeemVoucherData,
  SaleControllerRedeemVoucherResponses,
  SaleControllerRefundData,
  SaleControllerRefundResponses,
  SaleControllerUpdateData,
  SaleControllerUpdateDateData,
  SaleControllerUpdateDateResponses,
  SaleControllerUpdateResponses,
  SaleSchedulerControllerNormalizeEmecefData,
  SaleSchedulerControllerNormalizeEmecefErrors,
  SaleSchedulerControllerNormalizeEmecefResponses,
  StockExportControllerCreateStockExportData,
  StockExportControllerCreateStockExportResponses,
  StockExportControllerStockExportDataData,
  StockExportControllerStockExportDataResponses,
  StockHistoryControllerGetStockHistoryData,
  StockHistoryControllerGetStockHistoryResponses,
  StockItemControllerCreateDepackagedStockItemData,
  StockItemControllerCreateDepackagedStockItemResponses,
  StockItemControllerCreateStockItemData,
  StockItemControllerCreateStockItemResponses,
  StockItemControllerDeleteStockItemData,
  StockItemControllerDeleteStockItemResponses,
  StockItemControllerRestockStockItemData,
  StockItemControllerRestockStockItemResponses,
  StockItemControllerUpdateStockItemData,
  StockItemControllerUpdateStockItemResponses,
  StockItemControllerUpdateStockItemSalePriceData,
  StockItemControllerUpdateStockItemSalePriceResponses,
  StockSchedulerControllerCalculateStockValueData,
  StockSchedulerControllerCalculateStockValueErrors,
  StockSchedulerControllerCalculateStockValueResponses,
  SupplierControllerCreateData,
  SupplierControllerCreateResponses,
  SupplierControllerGetAllData,
  SupplierControllerGetAllResponses,
  SupplierControllerGetData,
  SupplierControllerGetPageData,
  SupplierControllerGetPageResponses,
  SupplierControllerGetResponses,
  SupplierControllerUpdateData,
  SupplierControllerUpdateResponses,
  TagControllerGetManyData,
  TagControllerGetManyResponses,
  ThresholdSettingsCloudControllerComputeThresholdsData,
  ThresholdSettingsCloudControllerComputeThresholdsResponses,
  ThresholdSettingsControllerComputeThresholdsData,
  ThresholdSettingsControllerComputeThresholdsResponses,
  ThresholdSettingsControllerCreateData,
  ThresholdSettingsControllerCreateResponses,
  ThresholdSettingsControllerDeleteData,
  ThresholdSettingsControllerDeleteResponses,
  ThresholdSettingsControllerFindAllData,
  ThresholdSettingsControllerFindAllResponses,
  ThresholdSettingsControllerUpdateData,
  ThresholdSettingsControllerUpdateResponses,
  UnitControllerGetManyData,
  UnitControllerGetManyResponses,
  UsageControllerGetAccountingReportData,
  UsageControllerGetAccountingReportDataForPdfData,
  UsageControllerGetAccountingReportDataForPdfResponses,
  UsageControllerGetAccountingReportResponses,
  UsageControllerGetBillingReportData,
  UsageControllerGetBillingReportResponses,
  UsageControllerGetCashRegisterJournalDataForPdfData,
  UsageControllerGetCashRegisterJournalDataForPdfResponses,
  UsageControllerGetDeliveriesByWholesalerData,
  UsageControllerGetDeliveriesByWholesalerResponses,
  UsageControllerGetExpensesReportData,
  UsageControllerGetExpensesReportDataData,
  UsageControllerGetExpensesReportDataResponses,
  UsageControllerGetExpensesReportResponses,
  UsageControllerGetProductsUnderControlSoldData,
  UsageControllerGetProductsUnderControlSoldResponses,
  UsageControllerGetSalesByDayData,
  UsageControllerGetSalesByDayResponses,
  UsageControllerGetSalesBySellerData,
  UsageControllerGetSalesBySellerResponses,
  UsageControllerGetSalesJournalData,
  UsageControllerGetSalesJournalResponses,
  UsageControllerGetSalesReportData,
  UsageControllerGetSalesReportDataData,
  UsageControllerGetSalesReportDataResponses,
  UsageControllerGetSalesReportResponses,
  UsageControllerGetSalesUsageData,
  UsageControllerGetSalesUsageResponses,
  UsageControllerGetTopSalesData,
  UsageControllerGetTopSalesResponses,
  UsageControllerGetTurnoverByCategoryData,
  UsageControllerGetTurnoverByCategoryResponses,
  UsageControllerGetTurnoverByStorageData,
  UsageControllerGetTurnoverByStorageResponses,
  UserControllerCreateData,
  UserControllerCreateResponses,
  UserControllerDeleteData,
  UserControllerDeleteResponses,
  UserControllerEnsureValidatorData,
  UserControllerEnsureValidatorResponses,
  UserControllerGetAllData,
  UserControllerGetAllResponses,
  UserControllerGetData,
  UserControllerGetManyData,
  UserControllerGetManyResponses,
  UserControllerGetMeData,
  UserControllerGetMembersData,
  UserControllerGetMembersResponses,
  UserControllerGetMeResponses,
  UserControllerGetResponses,
  UserControllerUpdateData,
  UserControllerUpdateResponses,
  WholesalerBillStatementControllerCreateData,
  WholesalerBillStatementControllerCreateErrors,
  WholesalerBillStatementControllerCreateResponses,
  WholesalerBillStatementControllerDeleteData,
  WholesalerBillStatementControllerDeleteErrors,
  WholesalerBillStatementControllerDeleteResponses,
  WholesalerBillStatementControllerGetRecordsData,
  WholesalerBillStatementControllerGetRecordsErrors,
  WholesalerBillStatementControllerGetRecordsResponses,
  WholesalerBillStatementControllerGetStatementsData,
  WholesalerBillStatementControllerGetStatementsErrors,
  WholesalerBillStatementControllerGetStatementsResponses,
  WholesalerBillStatementControllerGetWholesalerBillStatementByIdData,
  WholesalerBillStatementControllerGetWholesalerBillStatementByIdErrors,
  WholesalerBillStatementControllerGetWholesalerBillStatementByIdResponses,
  WholesalerBillStatementControllerUpdateWholesalerBillStatementData,
  WholesalerBillStatementControllerUpdateWholesalerBillStatementErrors,
  WholesalerBillStatementControllerUpdateWholesalerBillStatementResponses,
  WholesalerClaimControllerCreateData,
  WholesalerClaimControllerCreateErrors,
  WholesalerClaimControllerCreateResponses,
  WholesalerClaimControllerGetManyData,
  WholesalerClaimControllerGetManyResponses,
  WholesalerClaimControllerGetOneData,
  WholesalerClaimControllerGetOneErrors,
  WholesalerClaimControllerGetOneResponses,
  WholesalerClaimControllerUpdateData,
  WholesalerClaimControllerUpdateErrors,
  WholesalerClaimControllerUpdateResponses,
  WholesalerControllerGetManyData,
  WholesalerControllerGetManyResponses,
  WholesalerProductControllerCreateData,
  WholesalerProductControllerCreateResponses,
  WholesalerProductControllerDeleteData,
  WholesalerProductControllerDeleteResponses,
  WholesalerProductControllerGetManyData,
  WholesalerProductControllerGetManyResponses,
  WtwControllerGetWtwExportData,
  WtwControllerGetWtwExportResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const jwtControllerCreateToken = <ThrowOnError extends boolean = false>(
  options: Options<JwtControllerCreateTokenData, ThrowOnError>,
): RequestResult<JwtControllerCreateTokenResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<JwtControllerCreateTokenResponses, unknown, ThrowOnError>({
    url: "/tokens",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const healthControllerCheck = <ThrowOnError extends boolean = false>(
  options?: Options<HealthControllerCheckData, ThrowOnError>,
): RequestResult<HealthControllerCheckResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<HealthControllerCheckResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

export const healthControllerLiveness = <ThrowOnError extends boolean = false>(
  options?: Options<HealthControllerLivenessData, ThrowOnError>,
): RequestResult<HealthControllerLivenessResponses, HealthControllerLivenessErrors, ThrowOnError> =>
  (options?.client ?? client).get<HealthControllerLivenessResponses, HealthControllerLivenessErrors, ThrowOnError>({
    url: "/health/liveness",
    ...options,
  });

export const contractControllerGetAffiliated = <ThrowOnError extends boolean = false>(
  options?: Options<ContractControllerGetAffiliatedData, ThrowOnError>,
): RequestResult<ContractControllerGetAffiliatedResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ContractControllerGetAffiliatedResponses, unknown, ThrowOnError>({
    url: "/contracts/affiliated",
    ...options,
  });

export const contractControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<ContractControllerDeleteData, ThrowOnError>,
): RequestResult<ContractControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ContractControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/contracts/{id}",
    ...options,
  });

export const contractControllerGetById = <ThrowOnError extends boolean = false>(
  options: Options<ContractControllerGetByIdData, ThrowOnError>,
): RequestResult<ContractControllerGetByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ContractControllerGetByIdResponses, unknown, ThrowOnError>({
    url: "/contracts/{id}",
    ...options,
  });

export const contractControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ContractControllerUpdateData, ThrowOnError>,
): RequestResult<ContractControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ContractControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/contracts/{id}",
    ...options,
  });

export const contractControllerGetByCompanyId = <ThrowOnError extends boolean = false>(
  options: Options<ContractControllerGetByCompanyIdData, ThrowOnError>,
): RequestResult<ContractControllerGetByCompanyIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ContractControllerGetByCompanyIdResponses, unknown, ThrowOnError>({
    url: "/contracts/company/{id}",
    ...options,
  });

export const contractControllerDeleteFromPolicy = <ThrowOnError extends boolean = false>(
  options: Options<ContractControllerDeleteFromPolicyData, ThrowOnError>,
): RequestResult<ContractControllerDeleteFromPolicyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ContractControllerDeleteFromPolicyResponses, unknown, ThrowOnError>({
    url: "/contracts/policy/{id}",
    ...options,
  });

export const contractControllerCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ContractControllerCreateData, ThrowOnError>,
): RequestResult<ContractControllerCreateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ContractControllerCreateResponses, unknown, ThrowOnError>({
    url: "/contracts",
    ...options,
  });

export const contractPolicyControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<ContractPolicyControllerGetData, ThrowOnError>,
): RequestResult<ContractPolicyControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ContractPolicyControllerGetResponses, unknown, ThrowOnError>({
    url: "/contract-policies/{id}",
    ...options,
  });

export const contractPolicyControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ContractPolicyControllerUpdateData, ThrowOnError>,
): RequestResult<ContractPolicyControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ContractPolicyControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/contract-policies/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const contractPolicyControllerCreateFromCompanyContract = <ThrowOnError extends boolean = false>(
  options: Options<ContractPolicyControllerCreateFromCompanyContractData, ThrowOnError>,
): RequestResult<ContractPolicyControllerCreateFromCompanyContractResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ContractPolicyControllerCreateFromCompanyContractResponses, unknown, ThrowOnError>({
    url: "/contract-policies/company-contract",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const contractPolicyControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ContractPolicyControllerCreateData, ThrowOnError>,
): RequestResult<ContractPolicyControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ContractPolicyControllerCreateResponses, unknown, ThrowOnError>({
    url: "/contract-policies",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const personControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<PersonControllerGetAllData, ThrowOnError>,
): RequestResult<PersonControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PersonControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/persons/all",
    ...options,
  });

export const personControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<PersonControllerGetData, ThrowOnError>,
): RequestResult<PersonControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PersonControllerGetResponses, unknown, ThrowOnError>({
    url: "/persons/{id}",
    ...options,
  });

export const personControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PersonControllerUpdateData, ThrowOnError>,
): RequestResult<PersonControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PersonControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/persons/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const personControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<PersonControllerGetManyData, ThrowOnError>,
): RequestResult<PersonControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PersonControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/persons",
    ...options,
  });

export const personControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<PersonControllerCreateData, ThrowOnError>,
): RequestResult<PersonControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PersonControllerCreateResponses, unknown, ThrowOnError>({
    url: "/persons",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const personControllerGetOutgoing = <ThrowOnError extends boolean = false>(
  options: Options<PersonControllerGetOutgoingData, ThrowOnError>,
): RequestResult<PersonControllerGetOutgoingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PersonControllerGetOutgoingResponses, unknown, ThrowOnError>({
    url: "/persons/{id}/outgoing",
    ...options,
  });

export const personControllerGetBills = <ThrowOnError extends boolean = false>(
  options: Options<PersonControllerGetBillsData, ThrowOnError>,
): RequestResult<PersonControllerGetBillsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PersonControllerGetBillsResponses, unknown, ThrowOnError>({
    url: "/persons/{id}/bills",
    ...options,
  });

export const personControllerCreatePatientByQuickWay = <ThrowOnError extends boolean = false>(
  options: Options<PersonControllerCreatePatientByQuickWayData, ThrowOnError>,
): RequestResult<PersonControllerCreatePatientByQuickWayResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PersonControllerCreatePatientByQuickWayResponses, unknown, ThrowOnError>({
    url: "/persons/createPatientByQuickWay",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const personControllerUpdatePatientByQuickWay = <ThrowOnError extends boolean = false>(
  options: Options<PersonControllerUpdatePatientByQuickWayData, ThrowOnError>,
): RequestResult<PersonControllerUpdatePatientByQuickWayResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PersonControllerUpdatePatientByQuickWayResponses, unknown, ThrowOnError>({
    url: "/persons/{id}/quick-way",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const personContractPolicyControllerGetMany = <ThrowOnError extends boolean = false>(
  options: Options<PersonContractPolicyControllerGetManyData, ThrowOnError>,
): RequestResult<PersonContractPolicyControllerGetManyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PersonContractPolicyControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/persons/{id}/contract-policies",
    ...options,
  });

export const personRelationshipsControllerGetAll = <ThrowOnError extends boolean = false>(
  options: Options<PersonRelationshipsControllerGetAllData, ThrowOnError>,
): RequestResult<PersonRelationshipsControllerGetAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PersonRelationshipsControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/persons/{id}/relationships",
    ...options,
  });

export const personRelationshipsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<PersonRelationshipsControllerCreateData, ThrowOnError>,
): RequestResult<PersonRelationshipsControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PersonRelationshipsControllerCreateResponses, unknown, ThrowOnError>({
    url: "/persons/{id}/relationships",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const personRelationshipsControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<PersonRelationshipsControllerDeleteData, ThrowOnError>,
): RequestResult<PersonRelationshipsControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<PersonRelationshipsControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/persons/{id}/relationships/{relationshipId}",
    ...options,
  });

export const organizationControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<OrganizationControllerGetAllData, ThrowOnError>,
): RequestResult<OrganizationControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<OrganizationControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/organizations/all",
    ...options,
  });

export const organizationControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerGetData, ThrowOnError>,
): RequestResult<OrganizationControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationControllerGetResponses, unknown, ThrowOnError>({
    url: "/organizations/{id}",
    ...options,
  });

export const organizationControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerUpdateData, ThrowOnError>,
): RequestResult<OrganizationControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<OrganizationControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/organizations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const organizationControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<OrganizationControllerGetManyData, ThrowOnError>,
): RequestResult<OrganizationControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<OrganizationControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/organizations",
    ...options,
  });

export const organizationControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerCreateData, ThrowOnError>,
): RequestResult<OrganizationControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrganizationControllerCreateResponses, unknown, ThrowOnError>({
    url: "/organizations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const organizationControllerGetOutgoing = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerGetOutgoingData, ThrowOnError>,
): RequestResult<OrganizationControllerGetOutgoingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationControllerGetOutgoingResponses, unknown, ThrowOnError>({
    url: "/organizations/{id}/outgoing",
    ...options,
  });

export const organizationControllerGetBills = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerGetBillsData, ThrowOnError>,
): RequestResult<OrganizationControllerGetBillsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationControllerGetBillsResponses, unknown, ThrowOnError>({
    url: "/organizations/{id}/bills",
    ...options,
  });

export const organizationContractPolicyControllerGetMany = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationContractPolicyControllerGetManyData, ThrowOnError>,
): RequestResult<OrganizationContractPolicyControllerGetManyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationContractPolicyControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/organizations/{id}/contract-policies",
    ...options,
  });

export const organizationContractPolicyControllerGetManyByAffiliated = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationContractPolicyControllerGetManyByAffiliatedData, ThrowOnError>,
): RequestResult<OrganizationContractPolicyControllerGetManyByAffiliatedResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    OrganizationContractPolicyControllerGetManyByAffiliatedResponses,
    unknown,
    ThrowOnError
  >({ url: "/organizations/{id}/contract-policies/affiliate", ...options });

export const clientControllerGetPage = <ThrowOnError extends boolean = false>(
  options?: Options<ClientControllerGetPageData, ThrowOnError>,
): RequestResult<ClientControllerGetPageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ClientControllerGetPageResponses, unknown, ThrowOnError>({
    url: "/clients",
    ...options,
  });

export const billControllerGetPage = <ThrowOnError extends boolean = false>(
  options?: Options<BillControllerGetPageData, ThrowOnError>,
): RequestResult<BillControllerGetPageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<BillControllerGetPageResponses, unknown, ThrowOnError>({ url: "/bills", ...options });

export const billControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<BillControllerCreateData, ThrowOnError>,
): RequestResult<BillControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<BillControllerCreateResponses, unknown, ThrowOnError>({
    url: "/bills",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const billControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<BillControllerDeleteData, ThrowOnError>,
): RequestResult<BillControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<BillControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/bills/{id}",
    ...options,
  });

export const billControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<BillControllerGetData, ThrowOnError>,
): RequestResult<BillControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<BillControllerGetResponses, unknown, ThrowOnError>({ url: "/bills/{id}", ...options });

export const billControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<BillControllerUpdateData, ThrowOnError>,
): RequestResult<BillControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<BillControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/bills/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const tagControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<TagControllerGetManyData, ThrowOnError>,
): RequestResult<TagControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<TagControllerGetManyResponses, unknown, ThrowOnError>({ url: "/tags", ...options });

export const deliveryControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<DeliveryControllerGetManyData, ThrowOnError>,
): RequestResult<DeliveryControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<DeliveryControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/deliveries",
    ...options,
  });

export const deliveryControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<DeliveryControllerCreateData, ThrowOnError>,
): RequestResult<DeliveryControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DeliveryControllerCreateResponses, unknown, ThrowOnError>({
    url: "/deliveries",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const deliveryControllerGetReportCsv = <ThrowOnError extends boolean = false>(
  options: Options<DeliveryControllerGetReportCsvData, ThrowOnError>,
): RequestResult<DeliveryControllerGetReportCsvResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DeliveryControllerGetReportCsvResponses, unknown, ThrowOnError>({
    url: "/deliveries/deliveries-report-csv",
    ...options,
  });

export const deliveryControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<DeliveryControllerGetData, ThrowOnError>,
): RequestResult<DeliveryControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DeliveryControllerGetResponses, unknown, ThrowOnError>({
    url: "/deliveries/{id}",
    ...options,
  });

export const deliveryControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DeliveryControllerUpdateData, ThrowOnError>,
): RequestResult<DeliveryControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<DeliveryControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/deliveries/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderPreparationControllerFindRecords = <ThrowOnError extends boolean = false>(
  options: Options<OrderPreparationControllerFindRecordsData, ThrowOnError>,
): RequestResult<OrderPreparationControllerFindRecordsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrderPreparationControllerFindRecordsResponses, unknown, ThrowOnError>({
    url: "/order-preparations/records",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderPreparationControllerGetRecordStatByProductIds = <ThrowOnError extends boolean = false>(
  options: Options<OrderPreparationControllerGetRecordStatByProductIdsData, ThrowOnError>,
): RequestResult<OrderPreparationControllerGetRecordStatByProductIdsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrderPreparationControllerGetRecordStatByProductIdsResponses, unknown, ThrowOnError>({
    url: "/order-preparations/records-stat",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderPreparationControllerClose = <ThrowOnError extends boolean = false>(
  options: Options<OrderPreparationControllerCloseData, ThrowOnError>,
): RequestResult<OrderPreparationControllerCloseResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrderPreparationControllerCloseResponses, unknown, ThrowOnError>({
    url: "/order-preparations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<OrderControllerGetData, ThrowOnError>,
): RequestResult<OrderControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrderControllerGetResponses, unknown, ThrowOnError>({
    url: "/orders/{id}",
    ...options,
  });

export const orderControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrderControllerUpdateData, ThrowOnError>,
): RequestResult<OrderControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<OrderControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/orders/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<OrderControllerGetManyData, ThrowOnError>,
): RequestResult<OrderControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<OrderControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/orders",
    ...options,
  });

export const orderControllerGetCsv = <ThrowOnError extends boolean = false>(
  options: Options<OrderControllerGetCsvData, ThrowOnError>,
): RequestResult<OrderControllerGetCsvResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrderControllerGetCsvResponses, unknown, ThrowOnError>({
    url: "/orders/{id}/csv",
    ...options,
  });

export const orderControllerGetMeditectCsv = <ThrowOnError extends boolean = false>(
  options: Options<OrderControllerGetMeditectCsvData, ThrowOnError>,
): RequestResult<OrderControllerGetMeditectCsvResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrderControllerGetMeditectCsvResponses, unknown, ThrowOnError>({
    url: "/orders/{id}/meditect-csv",
    ...options,
  });

export const orderControllerGetExportData = <ThrowOnError extends boolean = false>(
  options: Options<OrderControllerGetExportDataData, ThrowOnError>,
): RequestResult<OrderControllerGetExportDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrderControllerGetExportDataResponses, unknown, ThrowOnError>({
    url: "/orders/{id}/export-data",
    ...options,
  });

export const orderRecordControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<OrderRecordControllerDeleteData, ThrowOnError>,
): RequestResult<OrderRecordControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<OrderRecordControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/order-records/{id}",
    ...options,
  });

/**
 * Get wholesaler bill statement records
 *
 * Retrieve records for a specific wholesaler with optional filtering
 */
export const wholesalerBillStatementControllerGetRecords = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerBillStatementControllerGetRecordsData, ThrowOnError>,
): RequestResult<
  WholesalerBillStatementControllerGetRecordsResponses,
  WholesalerBillStatementControllerGetRecordsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    WholesalerBillStatementControllerGetRecordsResponses,
    WholesalerBillStatementControllerGetRecordsErrors,
    ThrowOnError
  >({ url: "/wholesaler-bill-statements/{wholesalerId}/records", ...options });

/**
 * Get wholesaler bill statements
 *
 * Retrieve all bill statements for a specific wholesaler
 */
export const wholesalerBillStatementControllerGetStatements = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerBillStatementControllerGetStatementsData, ThrowOnError>,
): RequestResult<
  WholesalerBillStatementControllerGetStatementsResponses,
  WholesalerBillStatementControllerGetStatementsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    WholesalerBillStatementControllerGetStatementsResponses,
    WholesalerBillStatementControllerGetStatementsErrors,
    ThrowOnError
  >({ url: "/wholesaler-bill-statements/{wholesalerId}/statements", ...options });

/**
 * Delete wholesaler bill statement
 *
 * Delete an existing wholesaler bill statement
 */
export const wholesalerBillStatementControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerBillStatementControllerDeleteData, ThrowOnError>,
): RequestResult<
  WholesalerBillStatementControllerDeleteResponses,
  WholesalerBillStatementControllerDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    WholesalerBillStatementControllerDeleteResponses,
    WholesalerBillStatementControllerDeleteErrors,
    ThrowOnError
  >({ url: "/wholesaler-bill-statements/{id}", ...options });

/**
 * Get wholesaler bill statement by ID
 *
 * Retrieve a specific wholesaler bill statement by its ID
 */
export const wholesalerBillStatementControllerGetWholesalerBillStatementById = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerBillStatementControllerGetWholesalerBillStatementByIdData, ThrowOnError>,
): RequestResult<
  WholesalerBillStatementControllerGetWholesalerBillStatementByIdResponses,
  WholesalerBillStatementControllerGetWholesalerBillStatementByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    WholesalerBillStatementControllerGetWholesalerBillStatementByIdResponses,
    WholesalerBillStatementControllerGetWholesalerBillStatementByIdErrors,
    ThrowOnError
  >({ url: "/wholesaler-bill-statements/{id}", ...options });

/**
 * Update wholesaler bill statement
 *
 * Update an existing wholesaler bill statement
 */
export const wholesalerBillStatementControllerUpdateWholesalerBillStatement = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerBillStatementControllerUpdateWholesalerBillStatementData, ThrowOnError>,
): RequestResult<
  WholesalerBillStatementControllerUpdateWholesalerBillStatementResponses,
  WholesalerBillStatementControllerUpdateWholesalerBillStatementErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    WholesalerBillStatementControllerUpdateWholesalerBillStatementResponses,
    WholesalerBillStatementControllerUpdateWholesalerBillStatementErrors,
    ThrowOnError
  >({
    url: "/wholesaler-bill-statements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create wholesaler bill statement
 *
 * Create a new wholesaler bill statement
 */
export const wholesalerBillStatementControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerBillStatementControllerCreateData, ThrowOnError>,
): RequestResult<
  WholesalerBillStatementControllerCreateResponses,
  WholesalerBillStatementControllerCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    WholesalerBillStatementControllerCreateResponses,
    WholesalerBillStatementControllerCreateErrors,
    ThrowOnError
  >({
    url: "/wholesaler-bill-statements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const wholesalerProductControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<WholesalerProductControllerGetManyData, ThrowOnError>,
): RequestResult<WholesalerProductControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<WholesalerProductControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/wholesaler-products",
    ...options,
  });

export const wholesalerProductControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerProductControllerCreateData, ThrowOnError>,
): RequestResult<WholesalerProductControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<WholesalerProductControllerCreateResponses, unknown, ThrowOnError>({
    url: "/wholesaler-products",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const wholesalerProductControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerProductControllerDeleteData, ThrowOnError>,
): RequestResult<WholesalerProductControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<WholesalerProductControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/wholesaler-products/{id}",
    ...options,
  });

/**
 * Get all threshold settings for the current pharmacy
 */
export const thresholdSettingsControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<ThresholdSettingsControllerFindAllData, ThrowOnError>,
): RequestResult<ThresholdSettingsControllerFindAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ThresholdSettingsControllerFindAllResponses, unknown, ThrowOnError>({
    url: "/threshold-settings",
    ...options,
  });

/**
 * Create threshold settings
 */
export const thresholdSettingsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ThresholdSettingsControllerCreateData, ThrowOnError>,
): RequestResult<ThresholdSettingsControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ThresholdSettingsControllerCreateResponses, unknown, ThrowOnError>({
    url: "/threshold-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete threshold settings
 */
export const thresholdSettingsControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<ThresholdSettingsControllerDeleteData, ThrowOnError>,
): RequestResult<ThresholdSettingsControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ThresholdSettingsControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/threshold-settings/{id}",
    ...options,
  });

/**
 * Update threshold settings
 */
export const thresholdSettingsControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ThresholdSettingsControllerUpdateData, ThrowOnError>,
): RequestResult<ThresholdSettingsControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ThresholdSettingsControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/threshold-settings/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Compute thresholds based on settings and sales data
 */
export const thresholdSettingsControllerComputeThresholds = <ThrowOnError extends boolean = false>(
  options?: Options<ThresholdSettingsControllerComputeThresholdsData, ThrowOnError>,
): RequestResult<ThresholdSettingsControllerComputeThresholdsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ThresholdSettingsControllerComputeThresholdsResponses, unknown, ThrowOnError>({
    url: "/threshold-settings/compute",
    ...options,
  });

/**
 * Compute thresholds based on settings and sales data
 */
export const thresholdSettingsCloudControllerComputeThresholds = <ThrowOnError extends boolean = false>(
  options?: Options<ThresholdSettingsCloudControllerComputeThresholdsData, ThrowOnError>,
): RequestResult<ThresholdSettingsCloudControllerComputeThresholdsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ThresholdSettingsCloudControllerComputeThresholdsResponses, unknown, ThrowOnError>({
    url: "/threshold-settings-cloud/compute",
    ...options,
  });

export const importDeliveryControllerImportBl = <ThrowOnError extends boolean = false>(
  options: Options<ImportDeliveryControllerImportBlData, ThrowOnError>,
): RequestResult<ImportDeliveryControllerImportBlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ImportDeliveryControllerImportBlResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: "/delivery-imports",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

export const supplierControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<SupplierControllerGetAllData, ThrowOnError>,
): RequestResult<SupplierControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<SupplierControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/suppliers/all",
    ...options,
  });

export const supplierControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<SupplierControllerGetData, ThrowOnError>,
): RequestResult<SupplierControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<SupplierControllerGetResponses, unknown, ThrowOnError>({
    url: "/suppliers/{id}",
    ...options,
  });

export const supplierControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SupplierControllerUpdateData, ThrowOnError>,
): RequestResult<SupplierControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<SupplierControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/suppliers/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const supplierControllerGetPage = <ThrowOnError extends boolean = false>(
  options?: Options<SupplierControllerGetPageData, ThrowOnError>,
): RequestResult<SupplierControllerGetPageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<SupplierControllerGetPageResponses, unknown, ThrowOnError>({
    url: "/suppliers",
    ...options,
  });

export const supplierControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<SupplierControllerCreateData, ThrowOnError>,
): RequestResult<SupplierControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SupplierControllerCreateResponses, unknown, ThrowOnError>({
    url: "/suppliers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List wholesaler claims (paginated)
 *
 * Returns a paginated list of wholesaler claims for the authenticated pharmacy, optionally filtered by status, date range, full-text query, or supplier.
 */
export const wholesalerClaimControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<WholesalerClaimControllerGetManyData, ThrowOnError>,
): RequestResult<WholesalerClaimControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<WholesalerClaimControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/wholesaler-claims",
    ...options,
  });

/**
 * Create a wholesaler claim
 *
 * Creates a new wholesaler claim for the authenticated pharmacy, along with its product records. If a stock item ID is provided on a record, the corresponding stock quantity is deducted.
 */
export const wholesalerClaimControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerClaimControllerCreateData, ThrowOnError>,
): RequestResult<WholesalerClaimControllerCreateResponses, WholesalerClaimControllerCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    WholesalerClaimControllerCreateResponses,
    WholesalerClaimControllerCreateErrors,
    ThrowOnError
  >({
    url: "/wholesaler-claims",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a wholesaler claim by ID
 *
 * Returns a single wholesaler claim with its delivery and all product records, scoped to the authenticated pharmacy.
 */
export const wholesalerClaimControllerGetOne = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerClaimControllerGetOneData, ThrowOnError>,
): RequestResult<WholesalerClaimControllerGetOneResponses, WholesalerClaimControllerGetOneErrors, ThrowOnError> =>
  (options.client ?? client).get<
    WholesalerClaimControllerGetOneResponses,
    WholesalerClaimControllerGetOneErrors,
    ThrowOnError
  >({ url: "/wholesaler-claims/{id}", ...options });

/**
 * Update a wholesaler claim
 *
 * Updates an existing wholesaler claim. Existing records are replaced entirely. Stock quantity adjustments are recalculated based on the delta between previous and new claimed quantities.
 */
export const wholesalerClaimControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<WholesalerClaimControllerUpdateData, ThrowOnError>,
): RequestResult<WholesalerClaimControllerUpdateResponses, WholesalerClaimControllerUpdateErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    WholesalerClaimControllerUpdateResponses,
    WholesalerClaimControllerUpdateErrors,
    ThrowOnError
  >({
    url: "/wholesaler-claims/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const auditControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<AuditControllerGetManyData, ThrowOnError>,
): RequestResult<AuditControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AuditControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/audit",
    ...options,
  });

export const pharmacyControllerSoftDelete = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerSoftDeleteData, ThrowOnError>,
): RequestResult<PharmacyControllerSoftDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<PharmacyControllerSoftDeleteResponses, unknown, ThrowOnError>({
    url: "/pharmacies/{id}",
    ...options,
  });

export const pharmacyControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerGetData, ThrowOnError>,
): RequestResult<PharmacyControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyControllerGetResponses, unknown, ThrowOnError>({
    url: "/pharmacies/{id}",
    ...options,
  });

export const pharmacyControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerUpdateData, ThrowOnError>,
): RequestResult<PharmacyControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PharmacyControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/pharmacies/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyControllerGetPage = <ThrowOnError extends boolean = false>(
  options?: Options<PharmacyControllerGetPageData, ThrowOnError>,
): RequestResult<PharmacyControllerGetPageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PharmacyControllerGetPageResponses, unknown, ThrowOnError>({
    url: "/pharmacies",
    ...options,
  });

export const pharmacyControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerCreateData, ThrowOnError>,
): RequestResult<PharmacyControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PharmacyControllerCreateResponses, unknown, ThrowOnError>({
    url: "/pharmacies",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyControllerGetSubscription = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerGetSubscriptionData, ThrowOnError>,
): RequestResult<PharmacyControllerGetSubscriptionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyControllerGetSubscriptionResponses, unknown, ThrowOnError>({
    url: "/pharmacies/{id}/subscription",
    ...options,
  });

export const pharmacyControllerGetMany = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerGetManyData, ThrowOnError>,
): RequestResult<PharmacyControllerGetManyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/pharmacies/{id}/roles",
    ...options,
  });

export const pharmacyControllerGetUsers = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerGetUsersData, ThrowOnError>,
): RequestResult<PharmacyControllerGetUsersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyControllerGetUsersResponses, unknown, ThrowOnError>({
    url: "/pharmacies/{id}/users",
    ...options,
  });

export const pharmacyControllerUndoSoftDelete = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerUndoSoftDeleteData, ThrowOnError>,
): RequestResult<PharmacyControllerUndoSoftDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PharmacyControllerUndoSoftDeleteResponses, unknown, ThrowOnError>({
    url: "/pharmacies/{id}/undo-delete",
    ...options,
  });

export const pharmacyControllerUpdatePrinterSettings = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyControllerUpdatePrinterSettingsData, ThrowOnError>,
): RequestResult<PharmacyControllerUpdatePrinterSettingsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PharmacyControllerUpdatePrinterSettingsResponses, unknown, ThrowOnError>({
    url: "/pharmacies/{pharmacyId}/printer-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacySchedulerControllerHardDelete = <ThrowOnError extends boolean = false>(
  options: Options<PharmacySchedulerControllerHardDeleteData, ThrowOnError>,
): RequestResult<PharmacySchedulerControllerHardDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<PharmacySchedulerControllerHardDeleteResponses, unknown, ThrowOnError>({
    url: "/pharmacy-scheduler/hard-delete",
    ...options,
  });

export const pharmacyProductControllerGetStats = <ThrowOnError extends boolean = false>(
  options?: Options<PharmacyProductControllerGetStatsData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetStatsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PharmacyProductControllerGetStatsResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/stats",
    ...options,
  });

export const pharmacyProductControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<PharmacyProductControllerGetAllData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PharmacyProductControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/all",
    ...options,
  });

export const pharmacyProductControllerGetProductStats = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerGetProductStatsData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetProductStatsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyProductControllerGetProductStatsResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/{id}/stats",
    ...options,
  });

export const pharmacyProductControllerGetCountByStockQuantity = <ThrowOnError extends boolean = false>(
  options?: Options<PharmacyProductControllerGetCountByStockQuantityData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetCountByStockQuantityResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PharmacyProductControllerGetCountByStockQuantityResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/count-by-stock-quantity",
    ...options,
  });

export const pharmacyProductControllerGetByIds = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerGetByIdsData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetByIdsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PharmacyProductControllerGetByIdsResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/search/by-ids",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<PharmacyProductControllerGetManyData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PharmacyProductControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products",
    ...options,
  });

export const pharmacyProductControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerCreateData, ThrowOnError>,
): RequestResult<PharmacyProductControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PharmacyProductControllerCreateResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductControllerGetSubstituteProducts = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerGetSubstituteProductsData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetSubstituteProductsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyProductControllerGetSubstituteProductsResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/{id}/substitute-products",
    ...options,
  });

export const pharmacyProductControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerDeleteData, ThrowOnError>,
): RequestResult<PharmacyProductControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<PharmacyProductControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/{id}",
    ...options,
  });

export const pharmacyProductControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerGetData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyProductControllerGetResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/{id}",
    ...options,
  });

export const pharmacyProductControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerUpdateData, ThrowOnError>,
): RequestResult<PharmacyProductControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PharmacyProductControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductControllerUnpack = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerUnpackData, ThrowOnError>,
): RequestResult<PharmacyProductControllerUnpackResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PharmacyProductControllerUnpackResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/unpack",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductControllerDeleteDepackagingSettings = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerDeleteDepackagingSettingsData, ThrowOnError>,
): RequestResult<PharmacyProductControllerDeleteDepackagingSettingsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<PharmacyProductControllerDeleteDepackagingSettingsResponses, unknown, ThrowOnError>(
    { url: "/pharmacy-products/{pharmacyProductId}/depackaging-settings", ...options },
  );

export const pharmacyProductControllerUpsertDepackagingSettings = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerUpsertDepackagingSettingsData, ThrowOnError>,
): RequestResult<PharmacyProductControllerUpsertDepackagingSettingsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PharmacyProductControllerUpsertDepackagingSettingsResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/{pharmacyProductId}/depackaging-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductControllerBatchUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerBatchUpdateData, ThrowOnError>,
): RequestResult<PharmacyProductControllerBatchUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PharmacyProductControllerBatchUpdateResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/batch-update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductControllerTaxRateUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerTaxRateUpdateData, ThrowOnError>,
): RequestResult<PharmacyProductControllerTaxRateUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PharmacyProductControllerTaxRateUpdateResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/{id}/tax-rate-update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductControllerAssociateProduct = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerAssociateProductData, ThrowOnError>,
): RequestResult<PharmacyProductControllerAssociateProductResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PharmacyProductControllerAssociateProductResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/{id}/associate-product",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductControllerGetByDeliveryRecordId = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerGetByDeliveryRecordIdData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetByDeliveryRecordIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyProductControllerGetByDeliveryRecordIdResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/deliveryRecord/{id}",
    ...options,
  });

export const pharmacyProductControllerGetByStockItemId = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerGetByStockItemIdData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetByStockItemIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PharmacyProductControllerGetByStockItemIdResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/stockItem/{id}",
    ...options,
  });

export const pharmacyProductControllerGetArchivedProducts = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductControllerGetArchivedProductsData, ThrowOnError>,
): RequestResult<PharmacyProductControllerGetArchivedProductsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PharmacyProductControllerGetArchivedProductsResponses, unknown, ThrowOnError>({
    url: "/pharmacy-products/archivedProducts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductStorageControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<PharmacyProductStorageControllerGetAllData, ThrowOnError>,
): RequestResult<PharmacyProductStorageControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PharmacyProductStorageControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/pharmacy-product-storages",
    ...options,
  });

export const pharmacyProductStorageControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductStorageControllerCreateData, ThrowOnError>,
): RequestResult<PharmacyProductStorageControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PharmacyProductStorageControllerCreateResponses, unknown, ThrowOnError>({
    url: "/pharmacy-product-storages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const pharmacyProductStorageControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductStorageControllerDeleteData, ThrowOnError>,
): RequestResult<
  PharmacyProductStorageControllerDeleteResponses,
  PharmacyProductStorageControllerDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    PharmacyProductStorageControllerDeleteResponses,
    PharmacyProductStorageControllerDeleteErrors,
    ThrowOnError
  >({ url: "/pharmacy-product-storages/{id}", ...options });

export const pharmacyProductStorageControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PharmacyProductStorageControllerUpdateData, ThrowOnError>,
): RequestResult<PharmacyProductStorageControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PharmacyProductStorageControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/pharmacy-product-storages/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const stockExportControllerStockExportData = <ThrowOnError extends boolean = false>(
  options?: Options<StockExportControllerStockExportDataData, ThrowOnError>,
): RequestResult<StockExportControllerStockExportDataResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<StockExportControllerStockExportDataResponses, unknown, ThrowOnError>({
    url: "/stock-exports",
    ...options,
  });

export const stockExportControllerCreateStockExport = <ThrowOnError extends boolean = false>(
  options?: Options<StockExportControllerCreateStockExportData, ThrowOnError>,
): RequestResult<StockExportControllerCreateStockExportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<StockExportControllerCreateStockExportResponses, unknown, ThrowOnError>({
    url: "/stock-exports",
    ...options,
  });

export const stockItemControllerUpdateStockItem = <ThrowOnError extends boolean = false>(
  options: Options<StockItemControllerUpdateStockItemData, ThrowOnError>,
): RequestResult<StockItemControllerUpdateStockItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<StockItemControllerUpdateStockItemResponses, unknown, ThrowOnError>({
    url: "/stock-items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const stockItemControllerCreateStockItem = <ThrowOnError extends boolean = false>(
  options: Options<StockItemControllerCreateStockItemData, ThrowOnError>,
): RequestResult<StockItemControllerCreateStockItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<StockItemControllerCreateStockItemResponses, unknown, ThrowOnError>({
    url: "/stock-items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const stockItemControllerRestockStockItem = <ThrowOnError extends boolean = false>(
  options: Options<StockItemControllerRestockStockItemData, ThrowOnError>,
): RequestResult<StockItemControllerRestockStockItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<StockItemControllerRestockStockItemResponses, unknown, ThrowOnError>({
    url: "/stock-items/restock",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const stockItemControllerCreateDepackagedStockItem = <ThrowOnError extends boolean = false>(
  options: Options<StockItemControllerCreateDepackagedStockItemData, ThrowOnError>,
): RequestResult<StockItemControllerCreateDepackagedStockItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<StockItemControllerCreateDepackagedStockItemResponses, unknown, ThrowOnError>({
    url: "/stock-items/depackaged",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const stockItemControllerUpdateStockItemSalePrice = <ThrowOnError extends boolean = false>(
  options: Options<StockItemControllerUpdateStockItemSalePriceData, ThrowOnError>,
): RequestResult<StockItemControllerUpdateStockItemSalePriceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<StockItemControllerUpdateStockItemSalePriceResponses, unknown, ThrowOnError>({
    url: "/stock-items/sale-price/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const stockItemControllerDeleteStockItem = <ThrowOnError extends boolean = false>(
  options: Options<StockItemControllerDeleteStockItemData, ThrowOnError>,
): RequestResult<StockItemControllerDeleteStockItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<StockItemControllerDeleteStockItemResponses, unknown, ThrowOnError>({
    url: "/stock-items/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const stockSchedulerControllerCalculateStockValue = <ThrowOnError extends boolean = false>(
  options?: Options<StockSchedulerControllerCalculateStockValueData, ThrowOnError>,
): RequestResult<
  StockSchedulerControllerCalculateStockValueResponses,
  StockSchedulerControllerCalculateStockValueErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    StockSchedulerControllerCalculateStockValueResponses,
    StockSchedulerControllerCalculateStockValueErrors,
    ThrowOnError
  >({ url: "/stock-scheduler/compute-stock-value", ...options });

export const stockHistoryControllerGetStockHistory = <ThrowOnError extends boolean = false>(
  options?: Options<StockHistoryControllerGetStockHistoryData, ThrowOnError>,
): RequestResult<StockHistoryControllerGetStockHistoryResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<StockHistoryControllerGetStockHistoryResponses, unknown, ThrowOnError>({
    url: "/stock-history",
    ...options,
  });

export const brandControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<BrandControllerGetManyData, ThrowOnError>,
): RequestResult<BrandControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<BrandControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/brands",
    ...options,
  });

export const productCategoryControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<ProductCategoryControllerGetAllData, ThrowOnError>,
): RequestResult<ProductCategoryControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProductCategoryControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/product-categories",
    ...options,
  });

export const companyControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<CompanyControllerGetAllData, ThrowOnError>,
): RequestResult<CompanyControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CompanyControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/companies/all",
    ...options,
  });

export const companyControllerGetMany = <ThrowOnError extends boolean = false>(
  options: Options<CompanyControllerGetManyData, ThrowOnError>,
): RequestResult<CompanyControllerGetManyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CompanyControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/companies",
    ...options,
  });

export const wholesalerControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<WholesalerControllerGetManyData, ThrowOnError>,
): RequestResult<WholesalerControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<WholesalerControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/wholesalers",
    ...options,
  });

export const formControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<FormControllerGetManyData, ThrowOnError>,
): RequestResult<FormControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<FormControllerGetManyResponses, unknown, ThrowOnError>({ url: "/forms", ...options });

export const innControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<InnControllerGetManyData, ThrowOnError>,
): RequestResult<InnControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InnControllerGetManyResponses, unknown, ThrowOnError>({ url: "/inns", ...options });

export const innControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<InnControllerCreateData, ThrowOnError>,
): RequestResult<InnControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InnControllerCreateResponses, unknown, ThrowOnError>({
    url: "/inns",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const packagingControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<PackagingControllerGetManyData, ThrowOnError>,
): RequestResult<PackagingControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PackagingControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/packagings",
    ...options,
  });

export const productControllerGetByLabelWithHealthInsurance = <ThrowOnError extends boolean = false>(
  options?: Options<ProductControllerGetByLabelWithHealthInsuranceData, ThrowOnError>,
): RequestResult<ProductControllerGetByLabelWithHealthInsuranceResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProductControllerGetByLabelWithHealthInsuranceResponses, unknown, ThrowOnError>({
    url: "/products/with-health-insurance",
    ...options,
  });

export const productControllerGetByWholesalerProductLabel = <ThrowOnError extends boolean = false>(
  options?: Options<ProductControllerGetByWholesalerProductLabelData, ThrowOnError>,
): RequestResult<ProductControllerGetByWholesalerProductLabelResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProductControllerGetByWholesalerProductLabelResponses, unknown, ThrowOnError>({
    url: "/products/by-wholesaler-product-label",
    ...options,
  });

/**
 * Get paginated products
 *
 * Returns a paginated list of products, optionally filtered by code, brand, manufacturer, status, and other criteria.
 */
export const productControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<ProductControllerGetManyData, ThrowOnError>,
): RequestResult<ProductControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProductControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/products",
    ...options,
  });

export const productControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerCreateData, ThrowOnError>,
): RequestResult<ProductControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProductControllerCreateResponses, unknown, ThrowOnError>({
    url: "/products",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const productControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerDeleteData, ThrowOnError>,
): RequestResult<ProductControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProductControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/products/{id}",
    ...options,
  });

export const productControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerGetData, ThrowOnError>,
): RequestResult<ProductControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProductControllerGetResponses, unknown, ThrowOnError>({
    url: "/products/{id}",
    ...options,
  });

export const productControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerUpdateData, ThrowOnError>,
): RequestResult<ProductControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ProductControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/products/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const productControllerGetAllByProductId = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerGetAllByProductIdData, ThrowOnError>,
): RequestResult<ProductControllerGetAllByProductIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProductControllerGetAllByProductIdResponses, unknown, ThrowOnError>({
    url: "/products/{id}/pharmacy-products",
    ...options,
  });

export const productControllerGetFull = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerGetFullData, ThrowOnError>,
): RequestResult<ProductControllerGetFullResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProductControllerGetFullResponses, unknown, ThrowOnError>({
    url: "/products/{id}/details",
    ...options,
  });

export const productControllerGetNotice = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerGetNoticeData, ThrowOnError>,
): RequestResult<ProductControllerGetNoticeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProductControllerGetNoticeResponses, unknown, ThrowOnError>({
    url: "/products/{id}/notice",
    ...options,
  });

export const productControllerGetSpc = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerGetSpcData, ThrowOnError>,
): RequestResult<ProductControllerGetSpcResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProductControllerGetSpcResponses, unknown, ThrowOnError>({
    url: "/products/{id}/spc",
    ...options,
  });

export const productControllerCreateBatch = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerCreateBatchData, ThrowOnError>,
): RequestResult<ProductControllerCreateBatchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProductControllerCreateBatchResponses, unknown, ThrowOnError>({
    url: "/products/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const productControllerArchive = <ThrowOnError extends boolean = false>(
  options: Options<ProductControllerArchiveData, ThrowOnError>,
): RequestResult<ProductControllerArchiveResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProductControllerArchiveResponses, unknown, ThrowOnError>({
    url: "/products/archive",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const productControllerGetArchivedProducts = <ThrowOnError extends boolean = false>(
  options?: Options<ProductControllerGetArchivedProductsData, ThrowOnError>,
): RequestResult<ProductControllerGetArchivedProductsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ProductControllerGetArchivedProductsResponses, unknown, ThrowOnError>({
    url: "/products/archivedProducts",
    ...options,
  });

export const productControllerUpdateReferential = <ThrowOnError extends boolean = false>(
  options?: Options<ProductControllerUpdateReferentialData, ThrowOnError>,
): RequestResult<ProductControllerUpdateReferentialResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ProductControllerUpdateReferentialResponses, unknown, ThrowOnError>({
    url: "/products/update-referential",
    ...options,
  });

export const productViewControllerGetPage = <ThrowOnError extends boolean = false>(
  options?: Options<ProductViewControllerGetPageData, ThrowOnError>,
): RequestResult<ProductViewControllerGetPageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProductViewControllerGetPageResponses, unknown, ThrowOnError>({
    url: "/product-views",
    ...options,
  });

export const productViewControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProductViewControllerCreateData, ThrowOnError>,
): RequestResult<ProductViewControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProductViewControllerCreateResponses, unknown, ThrowOnError>({
    url: "/product-views",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const unitControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<UnitControllerGetManyData, ThrowOnError>,
): RequestResult<UnitControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UnitControllerGetManyResponses, unknown, ThrowOnError>({ url: "/units", ...options });

export const productHealthInsuranceControllerFindAllWithAssociatedProduct = <ThrowOnError extends boolean = false>(
  options: Options<ProductHealthInsuranceControllerFindAllWithAssociatedProductData, ThrowOnError>,
): RequestResult<ProductHealthInsuranceControllerFindAllWithAssociatedProductResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    ProductHealthInsuranceControllerFindAllWithAssociatedProductResponses,
    unknown,
    ThrowOnError
  >({ url: "/product-health-insurance/with-associated-product", ...options });

export const productHealthInsuranceControllerFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<ProductHealthInsuranceControllerFindAllData, ThrowOnError>,
): RequestResult<ProductHealthInsuranceControllerFindAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ProductHealthInsuranceControllerFindAllResponses, unknown, ThrowOnError>({
    url: "/product-health-insurance/all",
    ...options,
  });

export const productHealthInsuranceControllerAddProductsFromJson = <ThrowOnError extends boolean = false>(
  options: Options<ProductHealthInsuranceControllerAddProductsFromJsonData, ThrowOnError>,
): RequestResult<ProductHealthInsuranceControllerAddProductsFromJsonResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProductHealthInsuranceControllerAddProductsFromJsonResponses, unknown, ThrowOnError>({
    url: "/product-health-insurance/add-products-from-json",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Associer ou dissocier un produit santé
 *
 * Associe un produit à un produit santé ou dissocie le produit actuel
 */
export const productHealthInsuranceControllerAssociateProduct = <ThrowOnError extends boolean = false>(
  options: Options<ProductHealthInsuranceControllerAssociateProductData, ThrowOnError>,
): RequestResult<ProductHealthInsuranceControllerAssociateProductResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ProductHealthInsuranceControllerAssociateProductResponses, unknown, ThrowOnError>({
    url: "/product-health-insurance/associate-product/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Supprimer un produit santé
 *
 * Supprime un produit santé
 */
export const productHealthInsuranceControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<ProductHealthInsuranceControllerDeleteData, ThrowOnError>,
): RequestResult<ProductHealthInsuranceControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProductHealthInsuranceControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/product-health-insurance/{id}",
    ...options,
  });

/**
 * Mettre à jour les prix et taux d'un produit santé
 *
 * Met à jour le prix de base, le prix public et/ou le taux d'un produit santé
 */
export const productHealthInsuranceControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProductHealthInsuranceControllerUpdateData, ThrowOnError>,
): RequestResult<ProductHealthInsuranceControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ProductHealthInsuranceControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/product-health-insurance/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Créer un nouveau produit santé
 */
export const productHealthInsuranceControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProductHealthInsuranceControllerCreateData, ThrowOnError>,
): RequestResult<ProductHealthInsuranceControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProductHealthInsuranceControllerCreateResponses, unknown, ThrowOnError>({
    url: "/product-health-insurance",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const productHealthInsuranceControllerAddProductsFromPharmaPlus = <ThrowOnError extends boolean = false>(
  options: Options<ProductHealthInsuranceControllerAddProductsFromPharmaPlusData, ThrowOnError>,
): RequestResult<ProductHealthInsuranceControllerAddProductsFromPharmaPlusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    ProductHealthInsuranceControllerAddProductsFromPharmaPlusResponses,
    unknown,
    ThrowOnError
  >({
    url: "/product-health-insurance/add-products-from-pharma-plus",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const productAdviceControllerPopulateAdvicesByIds = <ThrowOnError extends boolean = false>(
  options: Options<ProductAdviceControllerPopulateAdvicesByIdsData, ThrowOnError>,
): RequestResult<ProductAdviceControllerPopulateAdvicesByIdsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProductAdviceControllerPopulateAdvicesByIdsResponses, unknown, ThrowOnError>({
    url: "/product-advice/populate-by-ids",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const productAdviceControllerPopulateAdvices = <ThrowOnError extends boolean = false>(
  options: Options<ProductAdviceControllerPopulateAdvicesData, ThrowOnError>,
): RequestResult<ProductAdviceControllerPopulateAdvicesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProductAdviceControllerPopulateAdvicesResponses, unknown, ThrowOnError>({
    url: "/product-advice/populate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Submit user feedback on a product advice
 */
export const productAdviceControllerSubmitFeedback = <ThrowOnError extends boolean = false>(
  options: Options<ProductAdviceControllerSubmitFeedbackData, ThrowOnError>,
): RequestResult<
  ProductAdviceControllerSubmitFeedbackResponses,
  ProductAdviceControllerSubmitFeedbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ProductAdviceControllerSubmitFeedbackResponses,
    ProductAdviceControllerSubmitFeedbackErrors,
    ThrowOnError
  >({
    url: "/product-advice/feedback/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const atcControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<AtcControllerGetManyData, ThrowOnError>,
): RequestResult<AtcControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AtcControllerGetManyResponses, unknown, ThrowOnError>({ url: "/atcs", ...options });

export const cashRegisterControllerGetReport = <ThrowOnError extends boolean = false>(
  options: Options<CashRegisterControllerGetReportData, ThrowOnError>,
): RequestResult<CashRegisterControllerGetReportResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CashRegisterControllerGetReportResponses, unknown, ThrowOnError>({
    url: "/cash-registers/report",
    ...options,
  });

export const cashRegisterControllerGetCurrentByUserId = <ThrowOnError extends boolean = false>(
  options: Options<CashRegisterControllerGetCurrentByUserIdData, ThrowOnError>,
): RequestResult<CashRegisterControllerGetCurrentByUserIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CashRegisterControllerGetCurrentByUserIdResponses, unknown, ThrowOnError>({
    url: "/cash-registers/current",
    ...options,
  });

export const cashRegisterControllerGetMany = <ThrowOnError extends boolean = false>(
  options: Options<CashRegisterControllerGetManyData, ThrowOnError>,
): RequestResult<CashRegisterControllerGetManyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CashRegisterControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/cash-registers",
    ...options,
  });

export const cashRegisterControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CashRegisterControllerCreateData, ThrowOnError>,
): RequestResult<CashRegisterControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CashRegisterControllerCreateResponses, unknown, ThrowOnError>({
    url: "/cash-registers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const cashRegisterControllerGetManyByDate = <ThrowOnError extends boolean = false>(
  options: Options<CashRegisterControllerGetManyByDateData, ThrowOnError>,
): RequestResult<CashRegisterControllerGetManyByDateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CashRegisterControllerGetManyByDateResponses, unknown, ThrowOnError>({
    url: "/cash-registers/by-date",
    ...options,
  });

export const cashRegisterControllerGet = <ThrowOnError extends boolean = false>(
  options?: Options<CashRegisterControllerGetData, ThrowOnError>,
): RequestResult<CashRegisterControllerGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CashRegisterControllerGetResponses, unknown, ThrowOnError>({
    url: "/cash-registers/{cashRegisterId}",
    ...options,
  });

export const cashRegisterControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CashRegisterControllerUpdateData, ThrowOnError>,
): RequestResult<CashRegisterControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<CashRegisterControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/cash-registers/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const movementControllerGetMovementsPage = <ThrowOnError extends boolean = false>(
  options?: Options<MovementControllerGetMovementsPageData, ThrowOnError>,
): RequestResult<MovementControllerGetMovementsPageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<MovementControllerGetMovementsPageResponses, unknown, ThrowOnError>({
    url: "/movements",
    ...options,
  });

export const movementControllerGetReport = <ThrowOnError extends boolean = false>(
  options?: Options<MovementControllerGetReportData, ThrowOnError>,
): RequestResult<MovementControllerGetReportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<MovementControllerGetReportResponses, unknown, ThrowOnError>({
    url: "/movements/report",
    ...options,
  });

export const movementControllerGetReportCsv = <ThrowOnError extends boolean = false>(
  options?: Options<MovementControllerGetReportCsvData, ThrowOnError>,
): RequestResult<MovementControllerGetReportCsvResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<MovementControllerGetReportCsvResponses, unknown, ThrowOnError>({
    url: "/movements/movement-report-csv",
    ...options,
  });

export const movementControllerGetReportData = <ThrowOnError extends boolean = false>(
  options?: Options<MovementControllerGetReportDataData, ThrowOnError>,
): RequestResult<MovementControllerGetReportDataResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<MovementControllerGetReportDataResponses, unknown, ThrowOnError>({
    url: "/movements/movement-report-data",
    ...options,
  });

export const disbursementReasonControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<DisbursementReasonControllerGetAllData, ThrowOnError>,
): RequestResult<DisbursementReasonControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<DisbursementReasonControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/disbursement-reasons",
    ...options,
  });

export const disbursementReasonControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<DisbursementReasonControllerCreateData, ThrowOnError>,
): RequestResult<DisbursementReasonControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DisbursementReasonControllerCreateResponses, unknown, ThrowOnError>({
    url: "/disbursement-reasons",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const disbursementControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<DisbursementControllerCreateData, ThrowOnError>,
): RequestResult<DisbursementControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DisbursementControllerCreateResponses, unknown, ThrowOnError>({
    url: "/disbursements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const disbursementControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<DisbursementControllerDeleteData, ThrowOnError>,
): RequestResult<DisbursementControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DisbursementControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/disbursements/{id}",
    ...options,
  });

export const disbursementControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<DisbursementControllerGetData, ThrowOnError>,
): RequestResult<DisbursementControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DisbursementControllerGetResponses, unknown, ThrowOnError>({
    url: "/disbursements/{id}",
    ...options,
  });

export const cashReplenishmentReasonControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<CashReplenishmentReasonControllerGetAllData, ThrowOnError>,
): RequestResult<CashReplenishmentReasonControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CashReplenishmentReasonControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/cash-replenishment-reasons",
    ...options,
  });

export const cashReplenishmentReasonControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CashReplenishmentReasonControllerCreateData, ThrowOnError>,
): RequestResult<CashReplenishmentReasonControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CashReplenishmentReasonControllerCreateResponses, unknown, ThrowOnError>({
    url: "/cash-replenishment-reasons",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const cashReplenishmentControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CashReplenishmentControllerCreateData, ThrowOnError>,
): RequestResult<CashReplenishmentControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CashReplenishmentControllerCreateResponses, unknown, ThrowOnError>({
    url: "/cash-replenishments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const cashReplenishmentControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<CashReplenishmentControllerDeleteData, ThrowOnError>,
): RequestResult<CashReplenishmentControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CashReplenishmentControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/cash-replenishments/{id}",
    ...options,
  });

export const cashReplenishmentControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<CashReplenishmentControllerGetData, ThrowOnError>,
): RequestResult<CashReplenishmentControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CashReplenishmentControllerGetResponses, unknown, ThrowOnError>({
    url: "/cash-replenishments/{id}",
    ...options,
  });

export const countryControllerGetManySections = <ThrowOnError extends boolean = false>(
  options: Options<CountryControllerGetManySectionsData, ThrowOnError>,
): RequestResult<CountryControllerGetManySectionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CountryControllerGetManySectionsResponses, unknown, ThrowOnError>({
    url: "/countries/{id}/sections",
    ...options,
  });

export const countryControllerGetManySuppliers = <ThrowOnError extends boolean = false>(
  options: Options<CountryControllerGetManySuppliersData, ThrowOnError>,
): RequestResult<CountryControllerGetManySuppliersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CountryControllerGetManySuppliersResponses, unknown, ThrowOnError>({
    url: "/countries/{id}/suppliers",
    ...options,
  });

export const countryControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<CountryControllerGetManyData, ThrowOnError>,
): RequestResult<CountryControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CountryControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/countries",
    ...options,
  });

export const currencyControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<CurrencyControllerGetManyData, ThrowOnError>,
): RequestResult<CurrencyControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CurrencyControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/currencies",
    ...options,
  });

export const printAgentControllerDownload = <ThrowOnError extends boolean = false>(
  options: Options<PrintAgentControllerDownloadData, ThrowOnError>,
): RequestResult<PrintAgentControllerDownloadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<PrintAgentControllerDownloadResponses, unknown, ThrowOnError>({
    url: "/print-agent/download/{platform}",
    ...options,
  });

export const reportsControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ReportsControllerCreateData, ThrowOnError>,
): RequestResult<ReportsControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ReportsControllerCreateResponses, unknown, ThrowOnError>({
    url: "/reports",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const roleControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<RoleControllerGetManyData, ThrowOnError>,
): RequestResult<RoleControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<RoleControllerGetManyResponses, unknown, ThrowOnError>({ url: "/roles", ...options });

export const roleControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<RoleControllerCreateData, ThrowOnError>,
): RequestResult<RoleControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<RoleControllerCreateResponses, unknown, ThrowOnError>({
    url: "/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const roleControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<RoleControllerDeleteData, ThrowOnError>,
): RequestResult<RoleControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<RoleControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/roles/{id}",
    ...options,
  });

export const roleControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<RoleControllerGetData, ThrowOnError>,
): RequestResult<RoleControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<RoleControllerGetResponses, unknown, ThrowOnError>({ url: "/roles/{id}", ...options });

export const roleControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<RoleControllerUpdateData, ThrowOnError>,
): RequestResult<RoleControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<RoleControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/roles/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const usageControllerGetAccountingReport = <ThrowOnError extends boolean = false>(
  options: Options<UsageControllerGetAccountingReportData, ThrowOnError>,
): RequestResult<UsageControllerGetAccountingReportResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UsageControllerGetAccountingReportResponses, unknown, ThrowOnError>({
    url: "/usage/accounting-report",
    ...options,
  });

export const usageControllerGetAccountingReportDataForPdf = <ThrowOnError extends boolean = false>(
  options: Options<UsageControllerGetAccountingReportDataForPdfData, ThrowOnError>,
): RequestResult<UsageControllerGetAccountingReportDataForPdfResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UsageControllerGetAccountingReportDataForPdfResponses, unknown, ThrowOnError>({
    url: "/usage/activity-report",
    ...options,
  });

export const usageControllerGetCashRegisterJournalDataForPdf = <ThrowOnError extends boolean = false>(
  options: Options<UsageControllerGetCashRegisterJournalDataForPdfData, ThrowOnError>,
): RequestResult<UsageControllerGetCashRegisterJournalDataForPdfResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UsageControllerGetCashRegisterJournalDataForPdfResponses, unknown, ThrowOnError>({
    url: "/usage/cash-register-journal/{cashRegisterId}",
    ...options,
  });

export const usageControllerGetBillingReport = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetBillingReportData, ThrowOnError>,
): RequestResult<UsageControllerGetBillingReportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetBillingReportResponses, unknown, ThrowOnError>({
    url: "/usage/billing-report",
    ...options,
  });

export const usageControllerGetSalesReport = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetSalesReportData, ThrowOnError>,
): RequestResult<UsageControllerGetSalesReportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetSalesReportResponses, unknown, ThrowOnError>({
    url: "/usage/sales-report",
    ...options,
  });

export const usageControllerGetSalesReportData = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetSalesReportDataData, ThrowOnError>,
): RequestResult<UsageControllerGetSalesReportDataResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetSalesReportDataResponses, unknown, ThrowOnError>({
    url: "/usage/sales-report-data",
    ...options,
  });

export const usageControllerGetSalesUsage = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetSalesUsageData, ThrowOnError>,
): RequestResult<UsageControllerGetSalesUsageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetSalesUsageResponses, unknown, ThrowOnError>({
    url: "/usage/sales",
    ...options,
  });

export const usageControllerGetSalesByDay = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetSalesByDayData, ThrowOnError>,
): RequestResult<UsageControllerGetSalesByDayResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetSalesByDayResponses, unknown, ThrowOnError>({
    url: "/usage/sales-by-day",
    ...options,
  });

export const usageControllerGetSalesBySeller = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetSalesBySellerData, ThrowOnError>,
): RequestResult<UsageControllerGetSalesBySellerResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetSalesBySellerResponses, unknown, ThrowOnError>({
    url: "/usage/sales-by-seller",
    ...options,
  });

export const usageControllerGetDeliveriesByWholesaler = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetDeliveriesByWholesalerData, ThrowOnError>,
): RequestResult<UsageControllerGetDeliveriesByWholesalerResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetDeliveriesByWholesalerResponses, unknown, ThrowOnError>({
    url: "/usage/deliveries-by-wholesaler",
    ...options,
  });

export const usageControllerGetTurnoverByCategory = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetTurnoverByCategoryData, ThrowOnError>,
): RequestResult<UsageControllerGetTurnoverByCategoryResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetTurnoverByCategoryResponses, unknown, ThrowOnError>({
    url: "/usage/turnover-by-category",
    ...options,
  });

export const usageControllerGetTurnoverByStorage = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetTurnoverByStorageData, ThrowOnError>,
): RequestResult<UsageControllerGetTurnoverByStorageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetTurnoverByStorageResponses, unknown, ThrowOnError>({
    url: "/usage/turnover-by-storage",
    ...options,
  });

export const usageControllerGetProductsUnderControlSold = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetProductsUnderControlSoldData, ThrowOnError>,
): RequestResult<UsageControllerGetProductsUnderControlSoldResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetProductsUnderControlSoldResponses, unknown, ThrowOnError>({
    url: "/usage/products-under-control-sold",
    ...options,
  });

export const usageControllerGetTopSales = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetTopSalesData, ThrowOnError>,
): RequestResult<UsageControllerGetTopSalesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetTopSalesResponses, unknown, ThrowOnError>({
    url: "/usage/top-sales",
    ...options,
  });

export const usageControllerGetSalesJournal = <ThrowOnError extends boolean = false>(
  options: Options<UsageControllerGetSalesJournalData, ThrowOnError>,
): RequestResult<UsageControllerGetSalesJournalResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UsageControllerGetSalesJournalResponses, unknown, ThrowOnError>({
    url: "/usage/sales-journal",
    ...options,
  });

export const usageControllerGetExpensesReport = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetExpensesReportData, ThrowOnError>,
): RequestResult<UsageControllerGetExpensesReportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetExpensesReportResponses, unknown, ThrowOnError>({
    url: "/usage/expenses-report-excel",
    ...options,
  });

export const usageControllerGetExpensesReportData = <ThrowOnError extends boolean = false>(
  options?: Options<UsageControllerGetExpensesReportDataData, ThrowOnError>,
): RequestResult<UsageControllerGetExpensesReportDataResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsageControllerGetExpensesReportDataResponses, unknown, ThrowOnError>({
    url: "/usage/expenses-report-pdf",
    ...options,
  });

export const userControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerGetManyData, ThrowOnError>,
): RequestResult<UserControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UserControllerGetManyResponses, unknown, ThrowOnError>({ url: "/users", ...options });

export const userControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerCreateData, ThrowOnError>,
): RequestResult<UserControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UserControllerCreateResponses, unknown, ThrowOnError>({
    url: "/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const userControllerGetMembers = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerGetMembersData, ThrowOnError>,
): RequestResult<UserControllerGetMembersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UserControllerGetMembersResponses, unknown, ThrowOnError>({
    url: "/users/members",
    ...options,
  });

export const userControllerEnsureValidator = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerEnsureValidatorData, ThrowOnError>,
): RequestResult<UserControllerEnsureValidatorResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UserControllerEnsureValidatorResponses, unknown, ThrowOnError>({
    url: "/users/ensure-validator",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const userControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerDeleteData, ThrowOnError>,
): RequestResult<UserControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<UserControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/users/{id}",
    ...options,
  });

export const userControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerGetData, ThrowOnError>,
): RequestResult<UserControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UserControllerGetResponses, unknown, ThrowOnError>({ url: "/users/{id}", ...options });

export const userControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerUpdateData, ThrowOnError>,
): RequestResult<UserControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<UserControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/users/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const userControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerGetAllData, ThrowOnError>,
): RequestResult<UserControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UserControllerGetAllResponses, unknown, ThrowOnError>({
    url: "/users/all",
    ...options,
  });

export const userControllerGetMe = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerGetMeData, ThrowOnError>,
): RequestResult<UserControllerGetMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UserControllerGetMeResponses, unknown, ThrowOnError>({
    url: "/users/me",
    ...options,
  });

export const inventoryControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<InventoryControllerDeleteData, ThrowOnError>,
): RequestResult<InventoryControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<InventoryControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/inventories/{id}",
    ...options,
  });

export const inventoryControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<InventoryControllerGetData, ThrowOnError>,
): RequestResult<InventoryControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InventoryControllerGetResponses, unknown, ThrowOnError>({
    url: "/inventories/{id}",
    ...options,
  });

export const inventoryControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<InventoryControllerGetManyData, ThrowOnError>,
): RequestResult<InventoryControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InventoryControllerGetManyResponses, unknown, ThrowOnError>({
    url: "/inventories",
    ...options,
  });

export const inventoryControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<InventoryControllerCreateData, ThrowOnError>,
): RequestResult<InventoryControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InventoryControllerCreateResponses, unknown, ThrowOnError>({
    url: "/inventories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const inventoryControllerClose = <ThrowOnError extends boolean = false>(
  options: Options<InventoryControllerCloseData, ThrowOnError>,
): RequestResult<InventoryControllerCloseResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<InventoryControllerCloseResponses, unknown, ThrowOnError>({
    url: "/inventories/{id}/close",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const inventoryControllerGetInventoryValuationReportData = <ThrowOnError extends boolean = false>(
  options: Options<InventoryControllerGetInventoryValuationReportDataData, ThrowOnError>,
): RequestResult<InventoryControllerGetInventoryValuationReportDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InventoryControllerGetInventoryValuationReportDataResponses, unknown, ThrowOnError>({
    url: "/inventories/getInventoryValuationReportData",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const bankControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<BankControllerGetManyData, ThrowOnError>,
): RequestResult<BankControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<BankControllerGetManyResponses, unknown, ThrowOnError>({ url: "/banks", ...options });

export const saleControllerGetMany = <ThrowOnError extends boolean = false>(
  options?: Options<SaleControllerGetManyData, ThrowOnError>,
): RequestResult<SaleControllerGetManyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<SaleControllerGetManyResponses, unknown, ThrowOnError>({ url: "/sales", ...options });

export const saleControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerCreateData, ThrowOnError>,
): RequestResult<SaleControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaleControllerCreateResponses, unknown, ThrowOnError>({
    url: "/sales",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const saleControllerGetManyWithVouchers = <ThrowOnError extends boolean = false>(
  options?: Options<SaleControllerGetManyWithVouchersData, ThrowOnError>,
): RequestResult<SaleControllerGetManyWithVouchersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<SaleControllerGetManyWithVouchersResponses, unknown, ThrowOnError>({
    url: "/sales/vouchers",
    ...options,
  });

export const saleControllerRedeemVoucher = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerRedeemVoucherData, ThrowOnError>,
): RequestResult<SaleControllerRedeemVoucherResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaleControllerRedeemVoucherResponses, unknown, ThrowOnError>({
    url: "/sales/vouchers/{voucherId}/redeem",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const saleControllerRefund = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerRefundData, ThrowOnError>,
): RequestResult<SaleControllerRefundResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaleControllerRefundResponses, unknown, ThrowOnError>({
    url: "/sales/{id}/refund",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const saleControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerDeleteData, ThrowOnError>,
): RequestResult<SaleControllerDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<SaleControllerDeleteResponses, unknown, ThrowOnError>({
    url: "/sales/{id}",
    ...options,
  });

export const saleControllerGet = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerGetData, ThrowOnError>,
): RequestResult<SaleControllerGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<SaleControllerGetResponses, unknown, ThrowOnError>({ url: "/sales/{id}", ...options });

export const saleControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerUpdateData, ThrowOnError>,
): RequestResult<SaleControllerUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<SaleControllerUpdateResponses, unknown, ThrowOnError>({
    url: "/sales/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const saleControllerNormalize = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerNormalizeData, ThrowOnError>,
): RequestResult<SaleControllerNormalizeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaleControllerNormalizeResponses, unknown, ThrowOnError>({
    url: "/sales/{id}/normalize",
    ...options,
  });

export const saleControllerUpdateDate = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerUpdateDateData, ThrowOnError>,
): RequestResult<SaleControllerUpdateDateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<SaleControllerUpdateDateResponses, unknown, ThrowOnError>({
    url: "/sales/{id}/date",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const saleControllerGetHistory = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerGetHistoryData, ThrowOnError>,
): RequestResult<SaleControllerGetHistoryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<SaleControllerGetHistoryResponses, unknown, ThrowOnError>({
    url: "/sales/{id}/history",
    ...options,
  });

export const saleControllerCreateProforma = <ThrowOnError extends boolean = false>(
  options: Options<SaleControllerCreateProformaData, ThrowOnError>,
): RequestResult<SaleControllerCreateProformaResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<SaleControllerCreateProformaResponses, unknown, ThrowOnError>({
    url: "/sales/proforma",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const meCeFControllerStatus = <ThrowOnError extends boolean = false>(
  options?: Options<MeCeFControllerStatusData, ThrowOnError>,
): RequestResult<MeCeFControllerStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<MeCeFControllerStatusResponses, unknown, ThrowOnError>({
    url: "/mecef/status",
    ...options,
  });

export const meCeFControllerTestToken = <ThrowOnError extends boolean = false>(
  options: Options<MeCeFControllerTestTokenData, ThrowOnError>,
): RequestResult<MeCeFControllerTestTokenResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<MeCeFControllerTestTokenResponses, unknown, ThrowOnError>({
    url: "/mecef/test-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const paymentControllerUpdateInsuranceMedata = <ThrowOnError extends boolean = false>(
  options: Options<PaymentControllerUpdateInsuranceMedataData, ThrowOnError>,
): RequestResult<PaymentControllerUpdateInsuranceMedataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PaymentControllerUpdateInsuranceMedataResponses, unknown, ThrowOnError>({
    url: "/payments/{paymentId}/insuranceMetadata",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const paymentControllerUpdateDeferredMedata = <ThrowOnError extends boolean = false>(
  options: Options<PaymentControllerUpdateDeferredMedataData, ThrowOnError>,
): RequestResult<PaymentControllerUpdateDeferredMedataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<PaymentControllerUpdateDeferredMedataResponses, unknown, ThrowOnError>({
    url: "/payments/{saleId}/deferredMetadata",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const saleSchedulerControllerNormalizeEmecef = <ThrowOnError extends boolean = false>(
  options?: Options<SaleSchedulerControllerNormalizeEmecefData, ThrowOnError>,
): RequestResult<
  SaleSchedulerControllerNormalizeEmecefResponses,
  SaleSchedulerControllerNormalizeEmecefErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SaleSchedulerControllerNormalizeEmecefResponses,
    SaleSchedulerControllerNormalizeEmecefErrors,
    ThrowOnError
  >({ url: "/sale-scheduler/normalize-emecef", ...options });

/**
 * Get paginated expenses
 */
export const expenseControllerGetPage = <ThrowOnError extends boolean = false>(
  options?: Options<ExpenseControllerGetPageData, ThrowOnError>,
): RequestResult<ExpenseControllerGetPageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ExpenseControllerGetPageResponses, unknown, ThrowOnError>({
    url: "/expenses",
    ...options,
  });

/**
 * Create a new expense
 */
export const expenseControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ExpenseControllerCreateData, ThrowOnError>,
): RequestResult<ExpenseControllerCreateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ExpenseControllerCreateResponses, unknown, ThrowOnError>({
    url: "/expenses",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get expense summary with analytics
 */
export const expenseControllerGetSummary = <ThrowOnError extends boolean = false>(
  options?: Options<ExpenseControllerGetSummaryData, ThrowOnError>,
): RequestResult<ExpenseControllerGetSummaryResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ExpenseControllerGetSummaryResponses, unknown, ThrowOnError>({
    url: "/expenses/summary",
    ...options,
  });

/**
 * Delete an expense
 */
export const expenseControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<ExpenseControllerRemoveData, ThrowOnError>,
): RequestResult<ExpenseControllerRemoveResponses, ExpenseControllerRemoveErrors, ThrowOnError> =>
  (options.client ?? client).delete<ExpenseControllerRemoveResponses, ExpenseControllerRemoveErrors, ThrowOnError>({
    url: "/expenses/{id}",
    ...options,
  });

/**
 * Update an expense
 */
export const expenseControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ExpenseControllerUpdateData, ThrowOnError>,
): RequestResult<ExpenseControllerUpdateResponses, ExpenseControllerUpdateErrors, ThrowOnError> =>
  (options.client ?? client).patch<ExpenseControllerUpdateResponses, ExpenseControllerUpdateErrors, ThrowOnError>({
    url: "/expenses/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const wtwControllerGetWtwExport = <ThrowOnError extends boolean = false>(
  options?: Options<WtwControllerGetWtwExportData, ThrowOnError>,
): RequestResult<WtwControllerGetWtwExportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<WtwControllerGetWtwExportResponses, unknown, ThrowOnError>({
    url: "/wtw/generate-export",
    ...options,
  });
